import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Number from '../number/number';

const Currency = props => {
  const { currency, hideNilDecimal, ...rest } = props;
  const { currency: local } = useIntl();

  if (hideNilDecimal) {
    rest.minimumFractionDigits = rest.value % 1 === 0 ? 0 : 2;
  }

  return (
    // eslint-disable-next-line react/style-prop-object
    <Number style='currency' round={2} currency={currency || local} {...rest} />
  );
};

export const CurrencyRenderer = (highlight, prefix) => value => (
  <Currency
    value={value}
    prefix={prefix}
    {...(highlight && { [highlight]: true })}
  />
);

export default Currency;

Currency.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  round: PropTypes.number,
  hideNilDecimal: PropTypes.bool
};

Currency.defaultProps = {
  value: 0,
  round: 2,
  hideNilDecimal: false
};
